function drawAudioData(buffer, canvas, canvasArea, opts) {
	if (__DEBUG__)
		console.debug('drawAudioData', { buffer, canvas, canvasArea, opts });

	if (!buffer || !canvas || !canvasArea) return;

	let leftChannel = buffer.getChannelData(0);
	let context = canvas.getContext('2d');

	let secondsPerScreen = canvasArea.offsetWidth / opts?.pixelsPerSecond;

	let canvasWidth = opts?.pixelsPerSecond ? buffer.duration * opts?.pixelsPerSecond : canvasArea.offsetWidth;
	let canvasHeight = canvasArea.offsetHeight;

	let realCanvasWidth = opts?.pixelsPerSecond ? buffer.duration * 1000 : canvasWidth;

	let drawLines = opts?.pixelsPerSecond ? buffer.duration * 1000 : canvasWidth * 5;

	canvas.width = realCanvasWidth;
	canvas.height = canvasArea.offsetHeight;

	context.save();
	context.fillStyle = 'transparent';
	context.fillRect(0, 0, realCanvasWidth, canvasHeight);
	context.strokeStyle = opts?.color || '#f27649';
	context.translate(0, canvasHeight / 2);
	context.lineWidth = Math.max(1, Math.min(5, 1 * 15 / secondsPerScreen));

	let totallength = leftChannel.length;
	let eachBlock = Math.floor(totallength / drawLines);
	let lineGap = (realCanvasWidth / drawLines);

	if (__DEBUG__)
		console.debug('Draw image', { canvasWidth, realCanvasWidth, lineGap, eachBlock, totallength, drawLines, secondsPerScreen, canvasHeight });

	context.beginPath();
	context.lineCap = 'round';
	for (let i = 0; i <= drawLines; i++) {
		let audioBuffKey = Math.floor(eachBlock * i);
		let x = i * lineGap;
		let y = leftChannel[audioBuffKey] * canvasHeight * (opts?.heightMultiplier || 1);
		context.moveTo(x, y);
		context.lineTo(x, y * -1);
	}
	context.stroke();
	context.restore();
}

export default {
	drawAudioData
}